import { PAGE_CODE } from "./pageCodeDefaults"

export const CONTACT_SUPPORT_MESSAGE = 'If the issues persists, please contact support via the Help icon on the navigation menu.';

export const elementShortNames = {
    market: {
        'Market Base Salary': { shortName: 'Base', stem: 'Market Base Salary' },
        'Market Actual Bonus/Incentive': { shortName: 'Bonus', stem: 'Market Actual Bonus/Incentive' },
        'Market Total Cash': { shortName: 'TC', stem: 'Market Total Cash' },
        'Market Target Bonus/Incentive': { shortName: 'Tar Bonus', stem: 'Market Target Bonus/Incentive' },
        'Market Total Target Cash': { shortName: 'TTC', stem: 'Market Total Target Cash' },
        'Market Actual LTI': { shortName: 'LTI', stem: 'Market Actual LTI' },
        'Market Total Direct': { shortName: 'TDC', stem: 'Market Total Direct' },
        'Market Total Target Direct': { shortName: 'TTDC', stem: 'Market Total Target Direct' },
        'Market Actual Sales Incentive': { shortName: 'Sales Inc', stem: 'Market Actual Sales Incentive' },
        'Market Target Sales Incentive': { shortName: 'Targ Sales Inc', stem: 'Market Target Sales Incentive' },
        'Market Cash Allowances': { shortName: 'Cash Allow', stem: 'Market Cash Allowances' },
        'Market Guaranteed Incentive': { shortName: 'Gar Inc', stem: 'Market Guaranteed Incentive' },
        'Market Fringe Benefits': { shortName: 'Fringe', stem: 'Market Fringe Benefits' },
        'Market Total Cost of Employment': { shortName: 'TCE', stem: 'Market Total Cost of Employment' },
        'Market Total Remuneration': { shortName: 'TR', stem: 'Market Total Remuneration' },
        'Market Total Guaranteed Pay': { shortName: 'TGar Pay', stem: 'Market Total Guaranteed Pay' },
    },

    companyJobEEAggregates: {
        'Base Salary': { shortName: 'Base', stem: 'Base Salary' },
        'Base Salary: Compa Ratio': { shortName: 'Compa Ratio', stem: 'Compa Ratio' },
        'Short Term Incentives': { shortName: 'STI', stem: 'STI' },
        'Short Term Incentives: Lump Sum Amt': { shortName: 'Lump Sum Amt', stem: 'Lump Sum Amt'},
        'Long Term Incentives': { shortName: 'Total LTI Value', stem: 'Total LTI Value' },
        'Total Cash Compensation (calc)': { shortName: 'TCC', stem: 'Total Paid Cash' },
        'Total Direct Compensation (calc)': { shortName: 'TDC', stem: 'Total Direct Compensation' },
        'Total Compensation': { shortName: 'TC', stem: 'Total Compensation' },
        'Total Compensation: Total Guaranteed Pay': { shortName: 'Total Guaranteed Pay', stem: 'Total Guaranteed Pay' },
        'Total Compensation: Total Cost of Employment': { shortName: 'Total Cost of Employment', stem: 'Total Cost of Employment' },
        'Total Compensation: Total Remuneration': { shortName: 'Total Remuneration', stem: 'Total Remuneration' },
    },

    get ALL() {
        const all = Object.keys(this).reduce((acc, key) => {
            const desc = Object.getOwnPropertyDescriptor(this, key)
            if (desc.get) return acc;
            const val = this[key];
            return {...acc, ...val}
        }, {});

        return all;
    },

    get [PAGE_CODE.BULK_PRICING_SURVEY_SEARCH]() {
        return this.market;
    },

    get [PAGE_CODE.BULK_PRICING_ORG_JOBS]() {
        return { ...this.market, ...this.companyJobEEAggregates};
    }
}